export default __webpack_public_path__ + "static/media/govA.a448427f.png";